// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var currentBlockTextureId = "CurrentBlockTexture";

exports.currentBlockTextureId = currentBlockTextureId;
/* No side effect */
